module.exports = __webpack_public_path__ + "media/Video 98.13fc2ca5.mp4";